import React from 'react';

export default function GComprisCoinBadge({ amount }) {
  return (
    <span
      title={`${amount} ${amount === 1 ? 'coin' : 'coins'} for completing a level`}
      className="shrink-0 inline-flex items-center gap-1 rounded-full bg-amber-50 border border-amber-200 px-2 py-0.5 text-[13px] font-extrabold text-amber-700"
    >
      <span aria-hidden="true">🪙</span>
      {amount}
    </span>
  );
}
